import { useForm } from 'react-hook-form';

export interface DataForm {
  legal_type: string;
  fantasy_name: string;
  business_name: string;
  tax_id: string;
  activity: string;
  phone: string;
  email: string;
  character: unknown;
  representative_firstname: string;
  representative_lastname: string;
  representative_type: string;
  representative_number: string;
  birth_date: string;
  identifier: number;
}

export const useDataForm = () => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm<DataForm>();

  return {
    controls: {
      legal_type: register('legal_type', {}),
      fantasy_name: register('fantasy_name', {}),
      business_name: register('business_name', {}),
      RFC: register('tax_id', {}),
      activity: register('activity', {}),

      phone: register('phone', {}),
      email: register('email', {}),

      character: register('character', {}),
      representative_firstname: register('representative_firstname', {}),
      representative_lastname: register('representative_lastname', {}),
      document_type: register('representative_type', {}),
      document_number: register('representative_number', {}),
      birth_date: register('birth_date', {}),
      identifier: register('identifier', {}),
    },
    handleSubmit,
    reset,
    errors,
  };
};
